"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpAlert = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isString_1 = __importDefault(require("lodash/isString"));
var hooks_1 = require("../../../api/hooks");
var react_bootstrap_1 = require("react-bootstrap");
var DpAlert_styled_1 = require("./DpAlert.styled");
var link_1 = __importDefault(require("next/link"));
var DpAlert = function (_a) {
    var actionLabel = _a.actionLabel, actionLink = _a.actionLink, actionHandler = _a.actionHandler, message = _a.message, alertProps = __rest(_a, ["actionLabel", "actionLink", "actionHandler", "message"]);
    // ------------------------ State
    var _b = (0, react_1.useState)(true), showAlert = _b[0], setShowAlert = _b[1];
    var _c = (0, react_1.useState)(0), timer = _c[0], setTimer = _c[1];
    var hasActionLink = !(0, isEmpty_1.default)(actionLink);
    var hasActionHandler = (0, isFunction_1.default)(actionHandler);
    var hasActionLabel = !(0, isEmpty_1.default)(actionLabel);
    var showAlertLink = hasActionLink && hasActionLabel;
    var showAlertButton = !hasActionLink && hasActionHandler && hasActionLabel;
    (0, hooks_1.useMount)(function () {
        setTimer(window.setTimeout(function () {
            setShowAlert(false);
        }, 5000));
        return function () { return clearTimeout(timer); };
    });
    // ------------------------ Events
    var handleAlertAction = function (e) {
        var onClose = alertProps.onClose;
        if ((0, isFunction_1.default)(onClose)) {
            clearTimeout(timer);
            onClose(false, e);
        }
        if ((0, isFunction_1.default)(actionHandler)) {
            actionHandler();
        }
    };
    // ------------------------ Render
    return ((0, jsx_runtime_1.jsx)(DpAlert_styled_1.StyledAlert, { "aria-live": "polite", "aria-atomic": "true", className: "w-100", children: (0, jsx_runtime_1.jsxs)(react_bootstrap_1.Alert, __assign({}, alertProps, { show: showAlert, "data-testid": "alert", children: [(0, isString_1.default)(message) ? (0, jsx_runtime_1.jsx)("span", { children: message }) : message, showAlertLink && ((0, jsx_runtime_1.jsx)(link_1.default, { href: actionLink, legacyBehavior: false, prefetch: false, className: "alert-link", onClick: handleAlertAction, children: actionLabel })), showAlertButton && ((0, jsx_runtime_1.jsx)(react_bootstrap_1.Button, { className: "alert-button btn btn-link bg-transparent border-0", onClick: handleAlertAction, children: actionLabel }))] })) }));
};
exports.DpAlert = DpAlert;
exports.default = exports.DpAlert;
